/* OPULENT FRAGRANCE — Concentration & Performance v2.0 (inline styles fix) */
;(function(){
"use strict";
var C=[
  {id:"edc",nm:"Eau de Cologne",ab:"EDC",oil:[2,5],lon:[1,3],proj:20,sil:15,pr:"$",ch:"Whisper",desc:"The lightest touch. A refreshing splash that sits close to skin. Perfect for post-shower or hot summer days.",best:["Post-shower","Hot summer days","Gym bag"],c:"#5BA8C8",ic:"\uD83D\uDCA7"},
  {id:"edt",nm:"Eau de Toilette",ab:"EDT",oil:[5,15],lon:[3,6],proj:45,sil:40,pr:"$$",ch:"Conversational",desc:"The everyday workhorse. Noticeable within arm\u2019s reach without overwhelming. The sweet spot for office wear.",best:["Office & work","Daily wear","Warm weather"],c:"#7DB87D",ic:"\uD83C\uDF3F"},
  {id:"edp",nm:"Eau de Parfum",ab:"EDP",oil:[15,20],lon:[6,10],proj:70,sil:65,pr:"$$$",ch:"Statement",desc:"Rich, complex, long-lasting. Two sprays on pulse points and you\u2019re set for the evening. The niche standard.",best:["Date night","Evening","Cool weather"],c:"#D4A855",ic:"\u2726"},
  {id:"parfum",nm:"Parfum / Extrait",ab:"EXTRAIT",oil:[20,40],lon:[8,24],proj:90,sil:85,pr:"$$$$",ch:"Beast Mode",desc:"Maximum depth and nuclear longevity. One dab projects for hours. People smell you before they see you.",best:["Special occasions","Cold weather","Collectors"],c:"#C9574B",ic:"\uD83D\uDD25"}
];
var M=[{k:"proj",l:"Projection",d:"How far it radiates",ic:"\uD83D\uDCE1"},{k:"sil",l:"Sillage",d:"The trail you leave",ic:"\uD83D\uDCA8"},{k:"lon",l:"Longevity",d:"How long it lasts",ic:"\u23F1"}];
var ST=[
  {id:"skin",l:"Skin Scent",d:"Intimate, up close only",ic:"\uD83E\uDD2B",rc:["edc","edt"],tip:"Apply to pulse points only. EDT works best \u2014 smell great when someone leans in."},
  {id:"office",l:"Office Safe",d:"Pleasant, not distracting",ic:"\uD83D\uDCBC",rc:["edt","edp"],tip:"2-3 sprays EDT or light EDP. Stick to fresh/clean scents."},
  {id:"beast",l:"Beast Mode",d:"Commanding, fills a room",ic:"\u26A1",rc:["edp","parfum"],tip:"3-4 sprays EDP or Extrait on pulse points + clothing. Oud and amber project hardest."}
];

function injectCSS(){
  if(document.getElementById("oc-s"))return;
  var s=document.createElement("style");s.id="oc-s";
  s.textContent='@import url("https://fonts.googleapis.com/css2?family=Anybody:wght@400;500;600;700;800&family=Karla:wght@300;400;500&display=swap");'+
  '.oc-w{font-family:Karla,sans-serif;background:#070609;color:#F0ECE6;-webkit-font-smoothing:antialiased;max-width:800px;margin:0 auto;padding:48px 24px 80px}'+
  '.oc-w *{box-sizing:border-box;margin:0;padding:0}'+
  '.oc-hdr{text-align:center;margin-bottom:48px}'+
  '.oc-br{font-size:10px;letter-spacing:4px;text-transform:uppercase;color:#C9A96E;margin-bottom:10px}'+
  '.oc-tt{font-family:Anybody,sans-serif;font-weight:700;font-size:clamp(28px,6vw,46px);line-height:1.05;margin-bottom:14px;background:linear-gradient(135deg,#F0ECE6 30%,#C9A96E 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}'+
  '.oc-sb{font-size:14px;color:#928B82;font-weight:300;line-height:1.6;max-width:520px;margin:0 auto}'+
  '.oc-tabs{display:flex;gap:4px;margin-bottom:40px;background:#0F0E14;border-radius:12px;padding:4px}'+
  '.oc-tab{flex:1;padding:12px 8px;border:none;background:transparent;color:#5A544C;font-family:Karla,sans-serif;font-size:12px;cursor:pointer;border-radius:10px;transition:all .3s;text-align:center}'+
  '.oc-tab.on{background:#16151D;color:#C9A96E;border:1px solid #222030}'+
  '.oc-tab:hover:not(.on){color:#928B82}'+
  '.oc-cd{background:#0F0E14;border:1.5px solid #222030;border-radius:16px;padding:20px;cursor:pointer;transition:all .4s;margin-bottom:12px}'+
  '.oc-cd:hover{border-color:#332F42;transform:translateY(-2px)}.oc-cd.sl{cursor:default;transform:none}'+
  '.oc-ct{display:flex;align-items:center;gap:14px;margin-bottom:12px}'+
  '.oc-ci{font-size:32px}.oc-ca{font-family:Anybody,sans-serif;font-weight:700;font-size:18px;letter-spacing:1px}'+
  '.oc-cn{font-size:13px;color:#928B82;font-weight:300}'+
  '.oc-mt{display:flex;gap:12px;flex-wrap:wrap}.oc-mt span{font-size:11px;color:#5A544C;padding:4px 10px;background:#16151D;border-radius:6px;border:1px solid #222030}'+
  '.oc-ex{margin-top:20px;padding-top:20px;border-top:1px solid #222030}'+
  '.oc-ch{font-family:Anybody,sans-serif;font-weight:600;font-size:14px;letter-spacing:1px;text-transform:uppercase;margin-bottom:8px}'+
  '.oc-ds{font-size:13px;color:#928B82;line-height:1.7;font-weight:300;margin-bottom:20px}'+
  '.oc-btl{font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:#5A544C;margin-bottom:8px}'+
  '.oc-bts{display:flex;flex-wrap:wrap;gap:6px}.oc-bt{font-size:11px;padding:5px 12px;border-radius:14px;border:1px solid;background:transparent}'+
  '.oc-wsc{background:#0F0E14;border:1.5px solid #222030;border-radius:14px;padding:20px;cursor:pointer;transition:all .35s;margin-bottom:12px}'+
  '.oc-wsc:hover{border-color:#332F42;transform:translateY(-2px)}.oc-wsc.sl{border-color:#C9A96E;box-shadow:0 0 24px rgba(201,169,110,.1)}'+
  '.oc-wtp{display:flex;align-items:center;gap:14px;margin-bottom:6px}'+
  '.oc-wic{font-size:28px}.oc-wl{font-family:Anybody,sans-serif;font-weight:600;font-size:16px}.oc-wd{font-size:12px;color:#5A544C}'+
  '.oc-wex{margin-top:16px;padding-top:16px;border-top:1px solid #222030}'+
  '.oc-wti{font-size:13px;color:#928B82;line-height:1.6;font-weight:300;margin-bottom:14px}'+
  '.oc-wrl{font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:#5A544C;margin-bottom:8px}'+
  '.oc-wps{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:16px}'+
  '.oc-wp{display:flex;align-items:center;gap:6px;padding:8px 16px;background:#16151D;border:1px solid #222030;border-radius:10px;font-size:12px}'+
  '.oc-cpg{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:12px}'+
  '.oc-cph{text-align:center;padding:14px 8px;border-radius:12px;border:1px solid;display:flex;flex-direction:column;align-items:center;gap:4px}'+
  '.oc-cpab{font-family:Anybody,sans-serif;font-weight:700;font-size:11px;letter-spacing:1px}'+
  '.oc-cpls{display:flex;justify-content:space-around;margin-top:8px}.oc-cpl{font-size:11px;color:#5A544C;text-align:center}'+
  '.oc-bar-top{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px}'+
  '.oc-bar-l{font-size:12px;color:#928B82}.oc-bar-sl{font-size:10px;color:#5A544C;margin-left:8px;font-weight:300}'+
  '.oc-bar-v{font-family:Anybody,sans-serif;font-size:13px;font-weight:600}'+
  '@keyframes ocShim{0%{transform:translateX(-100%)}50%{transform:translateX(100%)}100%{transform:translateX(100%)}}'+
  '@media(max-width:600px){.oc-w{padding:28px 16px 60px}.oc-cpg{grid-template-columns:repeat(2,1fr)}}';
  document.head.appendChild(s);
}

function el(t,c,h){var e=document.createElement(t);if(c)e.className=c;if(h!==undefined)e.innerHTML=h;return e}

/* Bar with ALL styles inline — cannot be overridden by theme CSS */
function makeBar(pct,color,h){
  var track=document.createElement("div");
  track.setAttribute("style","width:100% !important;height:"+h+"px !important;background:#16151D !important;border-radius:"+(h/2)+"px !important;overflow:hidden !important;position:relative !important;margin-top:4px !important;margin-bottom:4px !important;display:block !important;");
  var fill=document.createElement("div");
  fill.setAttribute("style","width:"+pct+"% !important;height:"+h+"px !important;background:linear-gradient(90deg,"+color+"CC,"+color+") !important;border-radius:"+(h/2)+"px !important;position:relative !important;overflow:hidden !important;display:block !important;min-height:"+h+"px !important;");
  /* Shimmer overlay */
  var shim=document.createElement("div");
  shim.setAttribute("style","position:absolute !important;top:0 !important;left:0 !important;width:100% !important;height:100% !important;background:linear-gradient(90deg,transparent,rgba(255,255,255,.15),transparent) !important;animation:ocShim 2.5s ease-in-out infinite !important;");
  fill.appendChild(shim);
  track.appendChild(fill);
  return track;
}

function render(root){
  var tab="conc",selC=null,selS=null;

  function draw(){
    root.innerHTML="";
    var w=el("div","oc-w");
    w.appendChild(el("div","oc-hdr",'<div class="oc-br">FRAGRANCE GUIDE</div><h1 class="oc-tt">Concentration<br>& Performance</h1><p class="oc-sb">Learn how oil concentration affects projection, longevity, and sillage.</p>'));

    var tabs=el("div","oc-tabs");
    [["conc","Concentrations"],["style","Find Your Style"],["compare","Compare"]].forEach(function(t){
      var b=el("button","oc-tab"+(tab===t[0]?" on":""),t[1]);
      b.onclick=function(){tab=t[0];selC=null;selS=null;draw()};tabs.appendChild(b);});
    w.appendChild(tabs);

    if(tab==="conc"){
      C.forEach(function(cn){
        var cd=el("div","oc-cd"+(selC===cn.id?" sl":""));
        if(selC===cn.id){cd.style.cssText+="border-color:"+cn.c+" !important;box-shadow:0 0 32px rgba(0,0,0,.3),inset 0 0 32px rgba(0,0,0,.1) !important;"}
        cd.appendChild(el("div","oc-ct",'<span class="oc-ci">'+cn.ic+'</span><div><div class="oc-ca" style="color:'+cn.c+'">'+cn.ab+'</div><div class="oc-cn">'+cn.nm+'</div></div>'));
        cd.appendChild(el("div","oc-mt",'<span>'+cn.oil[0]+'\u2013'+cn.oil[1]+'% oil</span><span>'+cn.lon[0]+'\u2013'+cn.lon[1]+'h</span><span>'+cn.pr+'</span>'));
        if(selC===cn.id){
          var ex=el("div","oc-ex");
          var ch=el("div","oc-ch",cn.ch);ch.style.color=cn.c;ex.appendChild(ch);
          ex.appendChild(el("div","oc-ds",cn.desc));
          M.forEach(function(m){
            var v=m.k==="lon"?Math.round((cn.lon[1]/24)*100):cn[m.k];
            var row=el("div","","");row.style.marginBottom="14px";
            row.appendChild(el("div","oc-bar-top",'<span class="oc-bar-l">'+m.ic+" "+m.l+'<span class="oc-bar-sl">'+m.d+"</span></span>"+'<span class="oc-bar-v" style="color:'+cn.c+'">'+v+"%</span>"));
            row.appendChild(makeBar(v,cn.c,10));
            ex.appendChild(row);
          });
          var bestDiv=el("div","");
          bestDiv.appendChild(el("div","oc-btl","Best for:"));
          var bts=el("div","oc-bts");
          cn.best.forEach(function(b){var sp=el("span","oc-bt",b);sp.style.borderColor=cn.c+"40";sp.style.color=cn.c;bts.appendChild(sp)});
          bestDiv.appendChild(bts);ex.appendChild(bestDiv);cd.appendChild(ex);
        }
        cd.onclick=function(){selC=selC===cn.id?null:cn.id;draw()};
        w.appendChild(cd);
      });
    }

    if(tab==="style"){
      w.appendChild(el("div","","<div style='font-family:Anybody,sans-serif;font-weight:600;font-size:20px;text-align:center;margin-bottom:8px'>What\u2019s Your Wear Style?</div><div style='font-size:13px;color:#928B82;text-align:center;margin-bottom:28px;font-weight:300'>How do you want to be experienced?</div>"));
      ST.forEach(function(st){
        var iS=selS===st.id;var cd=el("div","oc-wsc"+(iS?" sl":""));
        cd.innerHTML='<div class="oc-wtp"><span class="oc-wic">'+st.ic+'</span><div><div class="oc-wl">'+st.l+'</div><div class="oc-wd">'+st.d+'</div></div></div>';
        if(iS){
          var ex=el("div","oc-wex");
          ex.appendChild(el("div","oc-wti",st.tip));
          ex.appendChild(el("div","oc-wrl","Recommended concentrations"));
          var pls=el("div","oc-wps");
          st.rc.forEach(function(rid){var rc=C.find(function(c){return c.id===rid});if(rc){
            var pill=el("div","oc-wp");pill.style.borderColor=rc.c+"40";
            pill.innerHTML='<span>'+rc.ic+'</span><span style="color:'+rc.c+';font-weight:500">'+rc.ab+'</span><span style="color:#5A544C;font-size:11px">'+rc.lon[0]+'\u2013'+rc.lon[1]+'h</span>';
            pls.appendChild(pill)}});
          ex.appendChild(pls);
          st.rc.forEach(function(rid){var rc=C.find(function(c){return c.id===rid});if(rc){
            var row=el("div","");row.style.marginBottom="14px";
            row.appendChild(el("div","oc-bar-top",'<span class="oc-bar-l">'+rc.ic+" "+rc.ab+' Projection</span><span class="oc-bar-v" style="color:'+rc.c+'">'+rc.proj+'%</span>'));
            row.appendChild(makeBar(rc.proj,rc.c,10));ex.appendChild(row)}});
          cd.appendChild(ex);
        }
        cd.onclick=function(){selS=iS?null:st.id;draw()};w.appendChild(cd);
      });
    }

    if(tab==="compare"){
      w.appendChild(el("div","","<div style='font-family:Anybody,sans-serif;font-weight:600;font-size:18px;text-align:center;margin-bottom:24px'>Side-by-Side Comparison</div>"));
      var gr=el("div","oc-cpg");
      C.forEach(function(cn){
        var col=el("div","");col.style.cssText="display:flex;flex-direction:column;gap:8px;";
        var hdr=el("div","oc-cph");hdr.style.background=cn.c+"12";hdr.style.borderColor=cn.c+"30";
        hdr.innerHTML='<span style="font-size:24px">'+cn.ic+'</span><span class="oc-cpab" style="color:'+cn.c+'">'+cn.ab+'</span>';
        col.appendChild(hdr);
        M.forEach(function(m){
          var v=m.k==="lon"?Math.round((cn.lon[1]/24)*100):cn[m.k];
          col.appendChild(makeBar(v,cn.c,6));
        });
        gr.appendChild(col);
      });
      w.appendChild(gr);
      w.appendChild(el("div","oc-cpls",'<div class="oc-cpl">\uD83D\uDCE1 Projection</div><div class="oc-cpl">\uD83D\uDCA8 Sillage</div><div class="oc-cpl">\u23F1 Longevity</div>'));
    }

    root.appendChild(w);
  }
  draw();
}

function mount(sel){injectCSS();var r=typeof sel==="string"?document.querySelector(sel):sel;if(!r)return;render(r)}
window.OpulentConc={mount:mount};
})();
